import { isEmpty, omit } from 'ramda'
import { useFilter, useFilterState } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import IconButton from '../../../components/actions/IconButton'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import FiltersBar from '../filters/FiltersBar'
import FastFilters from '../filters/FastFilters'
import ProcessesDropdown from '../../../containers/processes/ProcessesDropdown'

const ControlBar = ({ leftContent, rightContent, hideDateFilters, hideFastFilters, middleContent, selectedScreen }) => {
  const { t } = useTranslation()

  const { fixedFilterFields } = useFilterState()
  const filter = omit(fixedFilterFields, useFilter())
  const hasFilter = !isEmpty(filter)

  const [isFiltering, setFiltering] = useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  const { t: tProcesses } = useTranslation('processes')
  const searchOptions = [
    { label: tProcesses('processes.search.normal'), value: '', icon: 'BsSearch' },
    { label: tProcesses('processes.search.byReply'), value: 'REPLY_VALUE', icon: 'BsCardHeading' },
    { label: tProcesses('processes.search.byAdditionalField'), value: 'FIELD_VALUE', icon: 'RiListSettingsLine' },
    { label: tProcesses('processes.search.byDestination'), value: 'PLACE', icon: 'RiBuildingLine' }
  ]

  return (
    <>
      <Separator weight={4} />
      <Grid justify="space-between" gutter={0.3}>
        <Grid flex={1} gutter={0.3}>
          <Col>
            <ProcessesDropdown selected={selectedScreen} screen="service_orders" />
          </Col>
          <Col>
            <IconButton iconLeft="BsFunnel" label={t('filter')} transparent noWrap onClick={toggleFilter} />
          </Col>

          <Col>{leftContent}</Col>
        </Grid>

        <Col flex={3} align="center">
          {!hideFastFilters && (middleContent || <FastFilters />)}
        </Col>

        <Col flex={1}>{rightContent || <SearchInput options={searchOptions} />}</Col>
      </Grid>
      <Separator weight={4} />

      <FiltersBar open={isFiltering} onClose={hideFilter} hideDateFilters={hideDateFilters} />
    </>
  )
}

export default ControlBar
